import { PictureOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import type { CSSProperties } from 'react';

import styles from './EmptyImage.module.scss';

const DEFAULT_IMAGE_SIZE = 32;

type EmptyImageProps = {
  width?: number;
  height?: number;
  className?: string;
};

type EmptyImageStyle = CSSProperties & {
  '--empty-image-width'?: string;
  '--empty-image-height'?: string;
};

export const EmptyImage = ({ width, height, className }: EmptyImageProps) => {
  const imageWidth = width ?? height ?? DEFAULT_IMAGE_SIZE;
  const imageHeight = height ?? width ?? DEFAULT_IMAGE_SIZE;
  const style: EmptyImageStyle = {
    '--empty-image-width': `${imageWidth}px`,
    '--empty-image-height': `${imageHeight}px`,
  };

  return (
    <div className={classNames(styles.emptyImage, className)} style={style}>
      <PictureOutlined className={styles.icon} />
    </div>
  );
};
